import View from './SocialCookieException'
import { connect } from 'react-redux'

const mapStateToProps = state => ({
  locale: state.router.locale,
})

const SocialCookieException = connect(mapStateToProps)(View)

export default SocialCookieException
